// FinTrack — Komitenti (puna baza komitenata iz ERP-a)
// Import iz Excel-a, pregled, edit, brisanje, QuickBooks export, sortiranje

import { state } from './state.js';
import { sb } from './supabase.js';
import { toast, svgIcon, openEditModal, showLoading, hideLoading, showConfirm } from './ui.js';
import { fNum } from './utils.js';
import XLSX from 'xlsx-js-style';

let kfData = [], kfPage = 0;
const KF_PAGE_SIZE = 50;
let kfSortCol = 'sifra', kfSortAsc = true;

export async function loadKomitentiFull() {
  showLoading();
  try {
    const { data, error } = await sb.from('komitenti_full').select('*').is('deleted_at', null).order('sifra', { ascending: true });
    if (error) throw error;
    kfData = data || [];
    window.__ft_kfData = kfData; // expose za fuzzy match u exportu
  } catch (e) { kfData = []; toast('Greška pri učitavanju komitenata', 'err'); }
  kfPage = 0;
  hideLoading();
  renderKomitentiFull();
}

function sortKfData(arr) {
  return [...arr].sort((a, b) => {
    let va = a[kfSortCol] ?? '', vb = b[kfSortCol] ?? '';
    if (typeof va === 'number' && typeof vb === 'number') return kfSortAsc ? va - vb : vb - va;
    va = String(va).toLowerCase(); vb = String(vb).toLowerCase();
    return kfSortAsc ? va.localeCompare(vb) : vb.localeCompare(va);
  });
}

export function renderKomitentiFull() {
  const thead = document.querySelector('#pg-komitenti-full .dtbl thead tr');
  const tbody = document.getElementById('kfBody');
  const empty = document.getElementById('kfEmpty');
  const count = document.getElementById('kfCount');
  if (!tbody) return;
  tbody.textContent = '';
  if (count) count.textContent = kfData.length + ' komitenata';

  // Sortable headers
  if (thead) {
    thead.textContent = '';
    const cols = [
      { key: 'sifra', label: 'Šifra' }, { key: 'naziv', label: 'Naziv' },
      { key: 'mesto', label: 'Mesto' }, { key: 'pib', label: 'PIB' },
      { key: 'telefon', label: 'Telefon' }, { key: 'ziro_racun', label: 'Žiro račun' }, { key: null, label: '' }
    ];
    cols.forEach(c => {
      const th = document.createElement('th');
      th.textContent = c.label;
      if (c.key) {
        th.className = 'sortable' + (kfSortCol === c.key ? (kfSortAsc ? ' asc' : ' desc') : '');
        const si = document.createElement('span');
        si.className = 'sort-icon';
        si.textContent = kfSortCol === c.key ? (kfSortAsc ? '\u25B2' : '\u25BC') : '\u25B4';
        th.appendChild(si);
        th.onclick = () => { if (kfSortCol === c.key) kfSortAsc = !kfSortAsc; else { kfSortCol = c.key; kfSortAsc = true; } kfPage = 0; renderKomitentiFull(); };
      }
      thead.appendChild(th);
    });
  }

  const q = (document.getElementById('kfSearch')?.value || '').toLowerCase();
  let filtered = q ? kfData.filter(k =>
    (k.naziv || '').toLowerCase().includes(q) ||
    (k.mesto || '').toLowerCase().includes(q) ||
    (k.pib || '').toLowerCase().includes(q) ||
    String(k.sifra || '').includes(q)
  ) : kfData;

  filtered = sortKfData(filtered);

  if (!filtered.length) {
    if (empty) empty.style.display = 'block';
    return;
  }
  if (empty) empty.style.display = 'none';

  const start = kfPage * KF_PAGE_SIZE;
  const page = filtered.slice(start, start + KF_PAGE_SIZE);

  page.forEach(k => {
    const tr = document.createElement('tr');
    const td0 = document.createElement('td'); td0.style.cssText = 'font-family:var(--mn);color:var(--tx3)'; td0.textContent = k.sifra || '';
    const td1 = document.createElement('td'); td1.style.fontWeight = '600'; td1.textContent = k.naziv || '';
    const td2 = document.createElement('td'); td2.style.cssText = 'color:var(--tx2);font-size:12px'; td2.textContent = k.mesto || '';
    const td3 = document.createElement('td'); td3.style.cssText = 'font-family:var(--mn);font-size:12px'; td3.textContent = k.pib || '';
    const td4 = document.createElement('td'); td4.style.cssText = 'font-size:12px;color:var(--tx2)'; td4.textContent = k.telefon || '';
    const td5 = document.createElement('td'); td5.style.cssText = 'font-size:12px;color:var(--tx3);max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
    td5.textContent = k.ziro_racun || '';
    const td6 = document.createElement('td'); td6.style.cssText = 'white-space:nowrap;text-align:right';
    const btnEd = document.createElement('button'); btnEd.className = 'bsm'; btnEd.style.cssText = 'margin-right:6px;font-size:11px;padding:5px 10px';
    btnEd.appendChild(svgIcon('edit', 12)); btnEd.appendChild(document.createTextNode(' Izmeni'));
    btnEd.onclick = () => editKomitentFull(k);
    const btnDel = document.createElement('button'); btnDel.className = 'bsm dng'; btnDel.style.cssText = 'font-size:11px;padding:5px 10px';
    btnDel.appendChild(svgIcon('trash', 12)); btnDel.appendChild(document.createTextNode(' Obriši'));
    btnDel.onclick = () => deleteKomitentFull(k);
    td6.appendChild(btnEd); td6.appendChild(btnDel);
    tr.appendChild(td0); tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4); tr.appendChild(td5); tr.appendChild(td6);
    tbody.appendChild(tr);
  });

  renderKfPagination(filtered.length);
}

function renderKfPagination(total) {
  const box = document.getElementById('kfPagination');
  if (!box) return;
  box.textContent = '';
  const pages = Math.ceil(total / KF_PAGE_SIZE);
  if (pages <= 1) return;
  for (let i = 0; i < pages; i++) {
    const btn = document.createElement('button'); btn.className = 'bsm' + (i === kfPage ? ' active' : '');
    btn.style.cssText = i === kfPage ? 'background:var(--acc);color:#fff;min-width:32px' : 'min-width:32px';
    btn.textContent = i + 1;
    btn.onclick = () => { kfPage = i; renderKomitentiFull(); };
    box.appendChild(btn);
  }
}

const KF_FIELDS = [
  { label: 'Šifra', key: 'sifra', type: 'number', placeholder: 'Šifra komitenta' },
  { label: 'Naziv', key: 'naziv', placeholder: 'Ime firme' },
  { label: 'Adresa', key: 'adresa', placeholder: 'Ulica i broj' },
  { label: 'Mesto', key: 'mesto', placeholder: 'Grad' },
  { label: 'PIB', key: 'pib', placeholder: 'Poreski identifikacioni broj' },
  { label: 'Telefon', key: 'telefon', placeholder: 'Telefon' },
  { label: 'Žiro račun', key: 'ziro_racun', placeholder: 'Broj žiro računa' },
];

function buildKfFields(k) {
  return KF_FIELDS.map(f => ({ label: f.label, key: f.key, type: f.type || 'text', value: k ? (k[f.key] ?? '') : '', placeholder: f.placeholder || '' }));
}

function editKomitentFull(k) {
  openEditModal('Izmeni komitenta', buildKfFields(k), (vals) => {
    if (vals.sifra) vals.sifra = parseInt(vals.sifra) || 0;
    sb.from('komitenti_full').update(vals).eq('id', k.id)
      .then(({ error }) => {
        if (error) { toast('Greška: ' + error.message, 'err'); return; }
        Object.assign(k, vals);
        renderKomitentiFull();
        toast('Komitent ažuriran');
      });
  });
}

export function showAddKomitentFull() {
  openEditModal('Novi komitent', buildKfFields(null), (vals) => {
    if (!vals.naziv?.trim()) { toast('Naziv je obavezan', 'err'); return; }
    if (vals.sifra) vals.sifra = parseInt(vals.sifra) || 0;
    sb.from('komitenti_full').insert([vals])
      .then(({ data, error }) => {
        if (error) { toast('Greška: ' + error.message, 'err'); return; }
        toast('Komitent dodat');
        loadKomitentiFull();
      });
  });
}

function deleteKomitentFull(k) {
  showConfirm('Obrisati komitenta "' + k.naziv + '"?', () => {
    sb.from('komitenti_full').update({ deleted_at: new Date().toISOString() }).eq('id', k.id)
      .then(({ error }) => {
        if (error) { toast('Greška: ' + error.message, 'err'); return; }
        kfData = kfData.filter(x => x.id !== k.id);
        renderKomitentiFull();
        toast('Komitent obrisan');
      });
  });
}

export function handleKfImport(inp) {
  if (!inp.files.length) return;
  const f = inp.files[0]; inp.value = '';
  const r = new FileReader();
  r.onload = async (e) => {
    try {
      showLoading();
      const wb = XLSX.read(e.target.result, { type: 'array', raw: true });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true });
      if (rows.length < 2) { hideLoading(); toast('Prazan fajl', 'err'); return; }

      const data = rows.slice(1).filter(r => r[1]).map(r => ({
        sifra: parseInt(r[0]) || 0,
        naziv: String(r[1] || '').trim(),
        adresa: String(r[2] || '').trim(),
        mesto: String(r[3] || '').trim(),
        pib: String(r[4] || '').trim(),
        telefon: String(r[5] || '').trim(),
        ptt_broj: String(r[6] || '').trim(),
        maticni_broj: String(r[23] || r[24] || '').trim(),
        pdv_status: String(r[10] || '').trim(),
        rok_placanja: String(r[15] || '').trim(),
        ziro_racun: String(r[16] || '').trim(),
        kontakt_osoba: String(r[21] || '').trim()
      }));

      if (!data.length) { hideLoading(); toast('Nema podataka za import', 'err'); return; }

      await sb.from('komitenti_full').delete().neq('id', 0);

      const { data: count, error } = await sb.rpc('import_komitenti_full', { p_data: data });
      if (error) throw error;
      hideLoading();
      toast('Importovano ' + count + ' komitenata');
      loadKomitentiFull();
    } catch (e) { hideLoading(); toast('Greška: ' + (e.message || e), 'err'); }
  };
  r.readAsArrayBuffer(f);
}

// QuickBooks Customer/Vendor export
export function expKfQuickBooks() {
  if (!kfData.length) { toast('Nema komitenata za export', 'err'); return; }
  const wb = XLSX.utils.book_new();
  const hdr = ['Name', 'Company', 'Address', 'City', 'Phone', 'Tax ID', 'Account Number'];
  const rows = [hdr];
  kfData.forEach(k => {
    rows.push([
      k.naziv || '', k.naziv || '', k.adresa || '', k.mesto || '',
      k.telefon || '', k.pib || '', String(k.sifra || '')
    ]);
  });
  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws['!cols'] = [{ wch: 40 }, { wch: 40 }, { wch: 30 }, { wch: 20 }, { wch: 18 }, { wch: 14 }, { wch: 12 }];
  XLSX.utils.book_append_sheet(wb, ws, 'Customers');
  XLSX.writeFile(wb, 'quickbooks_customers.xlsx');
  if (state.CU) sb.rpc('log_audit', { p_user_id: state.CU.id, p_action: 'export_quickbooks', p_entity_type: 'komitenti_full', p_entity_name: 'quickbooks_customers.xlsx' }).then(null, e => console.error('SBIS:', e));
  toast('QuickBooks export kreiran (' + kfData.length + ' komitenata)');
}

export const debounceRenderKF = (() => { let t; return () => { clearTimeout(t); t = setTimeout(renderKomitentiFull, 300); }; })();
